import { get } from 'lodash'

import { Colors } from '@sigma-frontend-libs/commons'

import { components, icons } from '@/utils'

import buttonConfirm from '@/components/button/confirm'
import squircle from '@/components/icon/squircle'
import arrow from '@/components/misc/arrow'

const fields = [
  'id',
  'token'
]

function renderHeaderContent(h, options) {
  const { path, serviceName } = options

  return h(
    'div',
    {
      class: 'faic grid-gap--8'
    },
    [
      h(
        squircle,
        {
          props: {
            icon: icons.integration_instructions,
            color: Colors.grey
          }
        }
      ),
      this.getTranslate(`${serviceName}.subtitles.${path}`)
    ]
  )
}
function renderHeader(h, options, expanded) {
  return h(
    'div',
    {
      class: 'default-expansion-panel-header pl-2'
    },
    [
      renderHeaderContent.call(this, h, options),
      h(arrow, { props: { expanded } })
    ]
  )
}

function renderItem(h, options, field) {
  const { path, serviceName, defaults } = options
  const key = [ path, field ].filter(Boolean).join('.')
  const defaultValue = get(defaults, path)

  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy[field],
        label: this.getTranslate(`${serviceName}.labels.${key}`),
        defaultValue: defaultValue?.[field],
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy[field] = event
        }
      }
    }
  )
}
function renderItems(h, options) {
  return fields.map(field => {
    return renderItem.call(this, h, options, field)
  })
}
function renderForm(h, options) {
  return h(
    components.form,
    {
      class: 'grid grid-gap--8 grid-cols--2'
    },
    [ renderItems.call(this, h, options) ]
  )
}
function renderBody(h, options) {
  return h(
    'div',
    {
      class: 'pa-2'
    },
    [
      h(
        buttonConfirm,
        {
          props: {
            value: this.proxy,
            loading: this.loading,
            disabled: this.disabled
          },
          on: {
            input: () => {
              this.submit()
            }
          }
        },
        [ renderForm.call(this, h, options) ]
      )
    ]
  )
}

export default function(h, options) {
  return h(
    components['expansion-panel'],
    {
      props: {
        outline: true,
        rounded: true
      },
      scopedSlots: {
        header: ({ expanded }) => {
          return renderHeader.call(this, h, options, expanded)
        },
        default: () => {
          return renderBody.call(this, h, options)
        }
      }
    }
  )
}
